<!-- Step: SEARCH VIEW -->
<div id="step-search">
  <div
    *ngIf="
      ((configService.vaultProfileConfigSubject | async)
        ?.identityVerificationFailureCount || 0) >= 2
    "
    class="p-4 mb-4 text-sm text-yellow-800 rounded-lg bg-yellow-50"
    role="alert"
  >
    We were unable to verify your identity. Please search for your healthcare
    system below.
    <br />
    You can also
    <a [routerLink]="'/form/support'" class="underline">file a ticket</a> if you
    need help.
  </div>

  <div id="search-controls" class="space-y-2">
    <div class="flex items-end gap-2">
      <fdk-input
        id="search-input"
        class="flex-1"
        type="search"
        label="Search for your health system"
        [hideLabel]="true"
        placeholder="Search providers..."
        [(ngModel)]="filter.query"
        (keyup)="onKeyup($event)"
      />

      <fdk-icon-button
        id="search-filters"
        icon="filter"
        aria-label="Show filters"
        variant="primary"
        (click)="showFilters = !showFilters"
      />
    </div>

    <button
      *ngIf="
        (configService.searchConfigSubject | async)?.showSearchByLocation &&
        navigator?.geolocation!!
      "
      type="button"
      id="search-by-location"
      aria-label="Search using current location"
      (click)="requestUserLocation()"
      [disabled]="requestingLocation"
      class="inline-flex items-center gap-1 fdk-type-paragraph-s text-fdk-accent hover:text-[#5B47FB] focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <fdk-icon name="location-off" />
      Use my location
    </button>
  </div>

  <!-- Filter drawer -->
  <div
    *ngIf="showFilters"
    id="filters-overlay"
    class="filters-drawer-overlay"
    (click)="showFilters = false"
  >
    <section
      id="filters-container"
      class="filters-drawer space-y-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="filters-title"
      (click)="$event.stopPropagation()"
    >
      <h3 id="filters-title" class="fdk-type-heading-3 text-fdk-primary">
        Filter and Sort
      </h3>

      <!-- State filter -->
      <div class="relative">
        <fdk-select
          id="state-filter"
          label="State"
          [options]="stateOptions"
          [(ngModel)]="filter.locations[0]"
          (ngModelChange)="querySources(true)"
        />
      </div>

      <div class="relative">
        <fdk-select
          id="sort-filter"
          label="Sort by"
          [options]="sortOptions"
          [(ngModel)]="filter.sortBy"
          (ngModelChange)="sortByChanged()"
        />
      </div>

      <div *ngIf="filter.sortBy == 'location'" class="relative">
        <fdk-input
          id="zipcode-input"
          type="text"
          label="ZIP code"
          [hideLabel]="true"
          placeholder="Enter your zipcode"
          [(ngModel)]="sortByLocationZipcode"
          (ngModelChange)="sortByLocationZipcodeChanged()"
        />
        <button
          *ngIf="
            (configService.searchConfigSubject | async)?.showSearchByLocation &&
            navigator?.geolocation!!
          "
          type="button"
          id="sort-by-location"
          aria-label="Sort using current location"
          (click)="requestUserLocation()"
          [disabled]="requestingLocation"
          class="absolute inset-y-0 right-0 flex items-center px-3 text-gray-500 hover:text-[#5B47FB] focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="w-5 h-5"
          >
            <path d="M12 21c-3.6-4-6-7-6-9a6 6 0 1 1 12 0c0 2-2.4 5-6 9z" />
            <circle cx="12" cy="12" r="1" />
          </svg>
        </button>
      </div>
    </section>
  </div>

  <!-- Search results container -->
  <div
    class="flex flex-col gap-fdk-xxs mt-fdk-m"
    id="search-results"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    [infiniteScrollContainer]="'#page-scroll-container'"
    [fromRoot]="true"
    [scrollWindow]="false"
    (scrolled)="onScroll()"
  >
    <fdk-card
      *ngFor="let brand of lighthouseBrandList"
      [title]="brand.brand?.name || ''"
      [highlights]="brand.searchHighlights || []"
      [location]="getBrandLocations(brand.brand?.locations || [])"
      [initials]="getBrandInitials(brand.brand?.name || '')"
      [logo]="
        brand.brand?.id
          ? 'https://cdn.fastenhealth.com/logos/sources/' +
            brand.brand?.id +
            '.png'
          : ''
      "
      variant="more"
      (click)="selectBrand(brand.brand)"
    />
  </div>
  <app-health-system-search-skeleton *ngIf="loading" [showControls]="false" />

  <div *ngIf="!loading && lighthouseBrandList.length == 0">
    <div class="flex justify-center mt-fdk-xl">
      <fdk-illustration name="empty" />
    </div>
    <h3 class="fdk-type-heading-3 text-fdk-primary mt-fdk-m text-center">
      No results found 
    </h3>
    <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs">
      We couldn't find a provider matching your search. Try different keywords
      or filters.
    </p>
    <div class="flex justify-center mt-fdk-m">
      <fdk-button
        [routerLink]="'/form/healthsystem'"
        type="button"
        variant="secondary"
      >
        Request a provider
      </fdk-button>
    </div>
  </div>
</div>
<!-- End Step: SEARCH VIEW -->
